"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));
var _excluded = ["children"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ErrorBoundaryWrapper = function ErrorBoundaryWrapper(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var fetch = (0, _exchangeReactHooks.useFetch)();
  var location = (0, _exchangeReactHooks.useLocation)();
  var profile = (0, _exchangeReactHooks.useProfile)();
  var onError = (0, _react.useCallback)(function (error, _ref2) {
    var componentStack = _ref2.componentStack;
    return fetch('/log', {
      method: 'POST',
      body: JSON.stringify({
        type: 'error',
        content: {
          error: error === null || error === void 0 ? void 0 : error.toString(),
          componentStack: componentStack,
          location: "".concat(location === null || location === void 0 ? void 0 : location.pathname).concat(location === null || location === void 0 ? void 0 : location.search),
          username: profile === null || profile === void 0 ? void 0 : profile.username
        }
      })
    });
  }, [fetch, location, profile]);
  return /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, (0, _extends2.default)({
    onError: onError
  }, props), children);
};
var _default = exports.default = ErrorBoundaryWrapper;
//# sourceMappingURL=ErrorBoundaryWrapper.js.map